export enum BlockchainTxType {
  CreateDeal = "CreateDeal",
  CreateDoc = "CreateDoc",
  SignDoc = "SignDoc",
  CreatePayment = "CreatePayment",
  ReleaseUpfrontPayment = "ReleaseUpfrontPayment",
  RevertUpfrontPayment = "RevertUpfrontPayment",
  ReleaseFullPayment = "ReleaseFullPayment",
  RevertFullPayment = "RevertFullPayment",
  AddTokenSupply = "AddTokenSupply",
  SetTokenPrice = "SetTokenPrice",
  SetTokenCommission = "SetTokenCommission",
  SetTokenMinMaxAmount = "SetTokenMinMaxAmount",
  ToggleTokenPause = "ToggleTokenPause",
  AddNewToken = "AddNewToken",
  BuyRWA = "BuyRWA",
  SellRWA = "SellRWA",
  ConvertRWA = "ConvertRWA",
  SetConversionCommission = "SetConversionCommission",
  CreateAgriInvestment = "CreateAgriInvestment",
}
